import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbPaginatedResponse } from 'libs/gb-dashboard/core/data-access/src'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { CategoriesEntity } from './categories.models'

@Injectable({
  providedIn: 'root',
})
export class CategoriesApiService extends GbApiService {
  getCategories(
    urlName: string,
    offset: number | undefined,
    limit: number | undefined,
    searchTerm: string | undefined,
  ): Observable<GbPaginatedResponse<CategoriesEntity>> {
    const paramsObject: any = {
      ordering: 'start',
      limit: limit || this.appConfig.itemsPageSize,
    }

    if (searchTerm) paramsObject.search = searchTerm
    if (offset) paramsObject.offset = offset

    const params = new HttpParams({
      fromObject: paramsObject,
    })

    const url = `auctions/${urlName}/categories/`

    return this.get<GbPaginatedResponse<CategoriesEntity>>(url, { params })
  }

  getCategory(urlName: string, categoryUuid: string): Observable<CategoriesEntity> {
    const url = `auctions/${urlName}categories/${categoryUuid}`

    return this.get<CategoriesEntity>(url)
  }

  updateCategory(category: CategoriesEntity): Observable<CategoriesEntity> {
    const url = `auctions/${category.auction}/categories/${category.uuid}/`
    return this.patch<CategoriesEntity>(url, category)
  }

  createCategory(urlName: string, label: string, items?: string[]): Observable<CategoriesEntity> {
    const url = `auctions/${urlName}/categories/`
    return this.post<CategoriesEntity>(url, {
      auction: urlName,
      label: label,
      items: items,
    })
  }

  deleteCategory(urlName: string, categoryUuid: string): Observable<void> {
    const url = `auctions/${urlName}/categories/${categoryUuid}/`
    return this.delete<void>(url)
  }

  updateCategoriesOrder(urlName: string, payload: { categories: string[] }): Observable<CategoriesEntity[]> {
    const url = `auctions/${urlName}/categories/reorder/`
    return this.post<CategoriesEntity[]>(url, payload)
  }
}
